export const getCronDisplayStatus = (cron) => {
    if (cron?.displayStatus != null) return cron.displayStatus;

    const processStatus = cron?.processStatus || null;
    return cron?.isPaused && processStatus !== "IN_PROGRESS" ? "PAUSED" : processStatus;
};
